/* eslint-disable */
import React, {Component} from 'react';
import Button from '@material-ui/core/Button'
import PropTypes from 'prop-types';
import client from '../../Services/client'
import AuthService from '../../Services/AuthService';
import { withStyles } from '@material-ui/core/styles';
import { BrowserRouter as Link } from "react-router-dom";
import { SimpleShareButtons } from "react-simple-share";
import styles from './Styles';
import ReactMarkdown from 'react-markdown'

import Grid from '@material-ui/core/Grid';


class SingleEvent extends Component {
	constructor(){
		super()
		this.Auth = new AuthService();
		this.state = {
			single_event: null,
			auth: false,
			lead: false,
			anchorEl: null,
			username: ''
		}
	}

	
	componentDidMount() {
   	 client.getEntries({content_type: 'events', 'fields.slug': this.props.match.params.slug})
      .then(response => {
        return response.items[0].fields;
      })
      .then(fields => {
        this.setState({
          single_event: fields
        });
      })
      .catch(console.error);
  }


	render(props){
		const { auth } = this.state;
		const {classes} = this.props;
		let title, description, date, place, url, slug, imageurl;
	
		if (this.state.single_event) {
		  title = this.state.single_event.title;
		  date = this.state.single_event.date;
		  place = this.state.single_event.place;
		  description = this.state.single_event.description;
          imageurl = this.state.single_event.imageEvents.fields.file.url; 
		  url = this.state.single_event.url;
		  slug = this.state.single_event.slug;
    	}
		 return(
			<div className={classes.layout}>
			 <Grid container>
              <Grid item md={6}>
				<div className={classes.imageLayout}>
					<img className={classes.img} alt="complex" src= {imageurl} />
				</div>
				<div className={classes.socialShare}>
					<h5>Share with</h5>
					<SimpleShareButtons
						url = {"https://poncianovieira.com/eventdetails/"+slug}
						size="50px"
					/>
				</div>
			  </Grid>
			  <Grid item md={6}>
			  <div className={classes.eventBody}>
			  		<h2>{title}</h2>
					<ReactMarkdown source={description} />
					<ReactMarkdown source={url} />

				</div>
			  </Grid>
			
			</Grid>
			</div>
		);
	}
}

SingleEvent.propTypes = {
	classes: PropTypes.object.isRequired,
  };
  
  export default withStyles(styles)(SingleEvent);




// WEBPACK FOOTER //
// ./src/components/Events/SingleEvent.js